<script lang="ts">
	//Stores
	import { sidePanelState } from 'src/stores/ui/sidepanel-public';
	//Design System Components
	import {
		Text,
		SidepanelLayout,
		SidepanelTabs,
		SidepanelContent,
	} from '@Shelly/shelly-design-system';
	//Helpers
	import { checkIsComponent } from '../../sidepanel-helpers';
	import { handleSidePanelTabClick, roomsTabsConfig } from '../../sidepanel-tabs-helpers';

	const ROOM_SIDE_PANEL_CONTENT_CONFIG = [
		'Tab 1 Content Component', // render first tab content component
		'Tab 2 Content Component', // render second tab content component
		'Tab 3 Content Component', // ...
		'Tab 4 Content Component',
	];

	let tabIndex: number = 0;
	let tabs = roomsTabsConfig;

	const onTabClick = (e: CustomEvent) => {
		const selectedTabData = e.detail;
		tabIndex = selectedTabData.index;
		tabs = handleSidePanelTabClick(tabs, tabIndex);
	};

	const resetActiveTab = () => {
		tabIndex = 0;
		tabs = roomsTabsConfig;
	};

	const handleSettings = () => {
		console.log('Sidepanel Settings clicked');
	};

	$: !$sidePanelState.open ? resetActiveTab() : null;
</script>

<SidepanelLayout title="Room Side Panel" subtitle="Subtitle" onSettings={handleSettings}>
	<SidepanelContent hideSlotStaticBottom={tabIndex !== 0}>
		<Text>POC SIDE PANEL ROOM CONTENT</Text>

		<svelte:component this={checkIsComponent(ROOM_SIDE_PANEL_CONTENT_CONFIG?.[tabIndex])} />

		<div slot="staticBottom">static bottom for rooms</div>

		<SidepanelTabs slot="tabs" {tabs} on:click={onTabClick} />
	</SidepanelContent>
</SidepanelLayout>
